var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"card",class:{
		selected: _vm.selected,
		hover: _vm.hover,
		inline: _vm.inline
	},attrs:{"disabled":_vm.$attrs.disabled,"tabindex":"0"},on:{"mousedown":function($event){$event.preventDefault();}}},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }